function initNewsletterPopup() {
  const popup = document.getElementById('NewsletterPopup');
  const closeBtn = document.getElementById('NewsletterPopupClose');
  const form = document.getElementById('ContactNewsletterPopup');
  
  // Steps
  const step1 = document.getElementById('PopupStep1');
  const step2 = document.getElementById('PopupStep2');
  const stepSuccess = document.getElementById('PopupStepSuccess');
  
  // Buttons & Controls
  const emailSubmitBtn = document.getElementById('PopupEmailSubmit');
  const smsSubmitBtn = document.getElementById('PopupSmsSubmit');
  const smsSkipBtn = document.getElementById('PopupSmsSkip');
  const successCloseBtn = document.getElementById('PopupCloseSuccess');
  const copyCodeBtn = document.getElementById('PopupCopyCodeBtn');
  const copyTip = document.getElementById('PopupCopyTip');
  
  // Inputs & Errors
  const emailInput = document.getElementById('NewsletterPopup-email');
  const phoneInput = document.getElementById('NewsletterPopup-phone');
  const tagsInput = document.getElementById('NewsletterPopupTags');
  const emailError = document.getElementById('PopupEmailError');
  const phoneError = document.getElementById('PopupPhoneError');
  
  const expiryDays = 14;
  const expiryMs = expiryDays * 24 * 60 * 60 * 1000;

  if (!popup || !form) return;

  // Helper to check if already dismissed or posted successfully recently
  function isDismissed() {
    // If URL contains test_popup=true, bypass check for debugging
    if (window.location.search.includes('test_popup=true')) {
      return false;
    }
    const dismissedTime = localStorage.getItem('sor_newsletter_dismissed_time');
    if (dismissedTime) {
      const elapsed = Date.now() - parseInt(dismissedTime, 10);
      if (elapsed < expiryMs) {
        return true;
      }
    }
    return false;
  }

  // Helper to dismiss popup for 14 days
  function dismissPopup() {
    localStorage.setItem('sor_newsletter_dismissed_time', Date.now().toString());
    hidePopup();
  }

  // Show popup logic
  let popupShown = false;
  function showPopup(force = false) {
    if (!force && (popupShown || isDismissed())) return;
    popupShown = true;
    popup.classList.remove('hidden');
    popup.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden'; // prevent page scrolling
  }

  // Hide popup logic
  function hidePopup() {
    popup.classList.add('hidden');
    popup.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = ''; // restore page scrolling
  }

  // Event Listener: Exit Intent (Mouse leaves viewport top)
  document.addEventListener('mouseleave', function(e) {
    if (e.clientY < 20) {
      showPopup();
    }
  });

  // Event Listener: Scroll Depth Trigger (> 60% scroll)
  let scrollActivated = false;
  window.addEventListener('scroll', function() {
    if (scrollActivated || popupShown || isDismissed()) return;
    const scrollableHeight = document.documentElement.scrollHeight - window.innerHeight;
    if (scrollableHeight <= 0) return;
    const scrollPercent = (window.scrollY / scrollableHeight) * 100;
    if (scrollPercent > 60) {
      scrollActivated = true;
      showPopup();
    }
  });

  // Event Listener: Time-based Backup Trigger (5 seconds delay, or 100ms if testing)
  const backupDelay = window.location.search.includes('test_popup=true') ? 100 : 5000;
  setTimeout(function() {
    if (!popupShown && !isDismissed()) {
      showPopup();
    }
  }, backupDelay);

  // Shopify Theme Editor Event Listeners
  if (typeof Shopify !== 'undefined' && Shopify.designMode) {
    document.addEventListener('shopify:section:select', function(e) {
      if (e.detail.sectionId && (e.detail.sectionId.includes('newsletter') || e.detail.sectionId.includes('popup') || e.detail.sectionId.includes('footer'))) {
        showPopup(true);
      }
    });
    document.addEventListener('shopify:section:deselect', function(e) {
      if (e.detail.sectionId && (e.detail.sectionId.includes('newsletter') || e.detail.sectionId.includes('popup') || e.detail.sectionId.includes('footer'))) {
        hidePopup();
      }
    });
  }

  // Close Event: Close Button Click
  if (closeBtn) {
    closeBtn.addEventListener('click', dismissPopup);
  }

  // Close Event: Click Outside the Content Box (Overlay background)
  popup.addEventListener('click', function(e) {
    if (e.target === popup) {
      dismissPopup();
    }
  });

  // Close Event: Escape Key Pressed
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && !popup.classList.contains('hidden')) {
      dismissPopup();
    }
  });

  // Step 1: Submit Email (AJAX) and Transition
  if (emailSubmitBtn && emailInput && step1 && step2) {
    emailSubmitBtn.addEventListener('click', function() {
      const emailVal = emailInput.value.trim();
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      
      if (!emailVal || !emailRegex.test(emailVal)) {
        if (emailError) emailError.style.display = 'block';
        return;
      }
      if (emailError) emailError.style.display = 'none';

      // Submit Email in the background using AJAX
      if (tagsInput) tagsInput.value = 'newsletter';
      const formData = new FormData(form);
      
      fetch('/contact', {
        method: 'POST',
        body: formData
      })
      .then(response => {
        console.log('Step 1 Email registered successfully');
      })
      .catch(err => {
        console.warn('Background contact submission error:', err);
      });

      // Move to Step 2 immediately for premium, snappy UX
      step1.classList.add('hidden-step');
      step1.classList.remove('active-step');
      
      step2.classList.remove('hidden-step');
      step2.classList.add('active-step');
    });
  }

  // Step 2: Submit SMS (AJAX) and Transition
  if (smsSubmitBtn && phoneInput && step2 && stepSuccess) {
    smsSubmitBtn.addEventListener('click', function() {
      const phoneVal = phoneInput.value.trim();
      // Support standard international/national phone validation (digits, spaces, hyphens, brackets, leading plus)
      const phoneRegex = /^(\+?\d{1,4}[\s-]?)?\(?\d{3}\)?[\s-]?\d{3}[\s-]?\d{4}$/;
      
      if (!phoneVal || !phoneRegex.test(phoneVal)) {
        if (phoneError) phoneError.style.display = 'block';
        return;
      }
      if (phoneError) phoneError.style.display = 'none';

      // Submit Phone number + Email to Shopify via AJAX
      if (tagsInput) tagsInput.value = 'newsletter, sms_opt_in';
      const formData = new FormData(form);

      fetch('/contact', {
        method: 'POST',
        body: formData
      })
      .then(response => {
        console.log('Step 2 SMS registered successfully');
      })
      .catch(err => {
        console.warn('Background SMS submission error:', err);
      });

      // Move to Success Step
      transitionToSuccess();
    });
  }

  // Step 2 Skip: Go directly to Success Step without collecting SMS
  if (smsSkipBtn) {
    smsSkipBtn.addEventListener('click', function() {
      transitionToSuccess();
    });
  }

  // Transition helper to Success state
  function transitionToSuccess() {
    // Set cookie/localStorage to prevent showing again since flow is complete
    localStorage.setItem('sor_newsletter_dismissed_time', Date.now().toString());

    if (step2) {
      step2.classList.add('hidden-step');
      step2.classList.remove('active-step');
    }
    
    if (stepSuccess) {
      stepSuccess.classList.remove('hidden-step');
      stepSuccess.classList.add('active-step');
    }
  }

  // Copy Promo Code to Clipboard
  if (copyCodeBtn && copyTip) {
    copyCodeBtn.addEventListener('click', function() {
      const promoCodeEl = document.getElementById('PopupPromoCode');
      const promoCode = promoCodeEl ? promoCodeEl.textContent : 'RESONANCE15';
      navigator.clipboard.writeText(promoCode).then(() => {
        copyTip.textContent = 'COPIED TO CLIPBOARD';
        copyCodeBtn.style.borderColor = 'hsl(40, 45%, 72%)';
        setTimeout(() => {
          copyTip.textContent = 'Click to copy code';
        }, 2000);
      }).catch(err => {
        console.error('Failed to copy promo code:', err);
      });
    });
  }

  // Success Step Close Button
  if (successCloseBtn) {
    successCloseBtn.addEventListener('click', function() {
      hidePopup();
    });
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initNewsletterPopup);
} else {
  initNewsletterPopup();
}
